import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import debounce from 'lodash.debounce';
import { getRequest, putRequest } from '../../requestUtils';
import StatusChangeForm from '../common/StatusChangeForm';
import StatusTracking from '../common/StatusTracking';
import spinnerDNA from '../../../assets/images/spinner-DNA-2s-200px.svg';
import './StatusChange.scss';

class StatusChange extends Component {
  constructor(props) {
    super();
    this.state = {
      modelOptions: props.modelOptions,
      modalStatusOptions: props.modalStatusOptions,
      modelStatusTracking: props.modelStatusTracking,
      modelSelected: props.modelSelected,
      modelStatus: props.modelStatus,
      modelName: props.modelName,
      reason: '',
      isLoading: false,
      error: '',
    };

    this.getSelectedModel = debounce(this.getSelectedModel.bind(this), 500);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateUrl = this.updateUrl.bind(this);
    this.renderStatusTracking = this.renderStatusTracking.bind(this);
  }

  getSelectedModel(resourceId) {
    const { csrfToken } = this.props;
    const { modelName } = this.state;
    this.setState({ isLoading: true });

    getRequest(`/${modelName.toLowerCase()}s/status_change?resource_id=${resourceId}`, csrfToken)
      .then((res) => {
        const { data } = res;
        this.setState({
          modelStatusTracking: data.modelStatusTracking,
          modelSelected: data.modelSelected,
          modelStatus: data.modelStatus,
          isLoading: false,
        });
      });
  }

  handleInputChange(input, value) {
    if (input === 'modelSelected') {
      this.updateUrl(value.value);
    }

    this.setState({ [input]: value, error: '' });
  }

  handleSubmit() {
    const {
      modelSelected, modelStatus, reason, modelName,
    } = this.state;
    const { csrfToken } = this.props;

    this.setState({ isLoading: true });
    putRequest(
      `/${modelName.toLowerCase()}s/${modelSelected.value}/admin_status_update`,
      {
        new_status: modelStatus.value,
        reason,
      },
      csrfToken,
    ).then((res) => {
      if (res.status === 200) {
        const { data } = res;
        this.setState({
          modelStatusTracking: data.status_changes,
          isLoading: false,
          reason: '',
        });
      }
    }).catch((e) => {
      this.setState({ error: e.message, isLoading: false });
    });
  }

  updateUrl(value) {
    const { modelName } = this.state;

    let url;
    if (value) {
      url = `/${modelName.toLowerCase()}s/status_change?resource_id=${value}`;
      this.getSelectedModel(value);
    } else {
      url = `/${modelName.toLowerCase()}s/status_change`;
      this.setState({ modelStatusTracking: [] });
    }
    window.history.replaceState(null, null, url);
  }

  renderStatusTracking() {
    const {
      modelSelected, modelStatusTracking, isLoading, modelName,
    } = this.state;

    if (!modelSelected) {
      return <h2>{`Select a ${modelName} to view status tracking`}</h2>;
    } if (modelSelected && modelStatusTracking.length === 0 && !isLoading) {
      return <h2>{`No status tracking history for this ${modelName}`}</h2>;
    }
    return (
      <StatusTracking
        statusTracking={modelStatusTracking}
      />
    );
  }

  render() {
    const {
      modelOptions,
      modalStatusOptions,
      modelSelected,
      modelStatus,
      reason,
      isLoading,
      error,
      modelName,
    } = this.state;

    const submitButtonDisabled = !modelSelected || !modelStatus || !reason;

    return (
      <Fragment>
        <StatusChangeForm
          title={`Change ${modelName} Status`}
          modelName={modelName.toLowerCase()}
          modelOptions={modelOptions}
          modalStatusOptions={modalStatusOptions}
          modelSelected={modelSelected}
          modelStatus={modelStatus}
          reason={reason}
          handleInputChange={this.handleInputChange}
          submitButtonDisabled={submitButtonDisabled}
          handleSubmit={this.handleSubmit}
          error={error}
        />
        <div className="status-tracking-history">
          { isLoading
            ? <SVG src={spinnerDNA} title="Cloar Spinner" />
            : this.renderStatusTracking()}
        </div>
      </Fragment>
    );
  }
}

StatusChange.propTypes = {
  modelOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  modalStatusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  modelSelected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
  modelStatus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
  modelStatusTracking: PropTypes.arrayOf(PropTypes.shape({})),
  csrfToken: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
};

StatusChange.defaultProps = {
  modelStatusTracking: [],
};

export default StatusChange;
